import { BaseIcon, Button, Modal } from "@shltelemedicine/shl-ui-lib";
import { PropsWithChildren, ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import ApprovedIcon from "../ApprovedIcon/ApprovedIcon";
import styles from "./ConfirmationModal.module.css";

export type ConfirmationModalProps = {
  show?: boolean;
  title?: ReactNode;
  headerIcon?: string;
  onClose?: () => void;
  okBtn?: {
    onClick?: () => void;
  };
  children?: ReactNode;
};

const ConfirmationModal = ({
  show,
  title,
  onClose,
  children,
  headerIcon,
}: PropsWithChildren<ConfirmationModalProps>) => {
  return (
    <>
      <Modal
        centered
        backdrop="static"
        show={show}
        onHide={onClose}
        contentClassName="h-100"
        footer={
          <div className="d-flex align-items-center justify-content-end border-top pt-2 px-3 m-sm-0">
            <Button
              className="capitalized justify-content-center w-25 "
              bgColor="transparent linear-gradient(180deg, #505F95 0%, #2C449A 100%) 0% 0% no-repeat padding-box"
              onClick={onClose}
            >
              <FormattedMessage id="GLOBAL.OK" defaultMessage="Ok" />
            </Button>
          </div>
        }
        header={
          <div className="d-flex align-items-center">
            {headerIcon && (
              <BaseIcon icon={headerIcon} className={styles.headerIcon} />
            )}
            <span className="mx-1"></span>
            <p className={`${styles.title} mb-0`}>{title}</p>
          </div>
        }
      >
        <div className="w-75 mx-auto py-3 text-center">
          <ApprovedIcon className={styles.approvedIcon} />
          &nbsp;&nbsp;
          {children}
        </div>
      </Modal>
    </>
  );
};

export default ConfirmationModal;
